import { Component } from '@angular/core';

@Component({
  selector: 'app-demo-instruction',
  templateUrl: './demo-instruction.component.html',
  styleUrl: './demo-instruction.component.scss',
})
export class DemoInstructionComponent {
  public openDemoInstruction: boolean = true;
  public modalOpen: boolean = true;

  public transition(): void {
    this.openDemoInstruction = !this.openDemoInstruction;
    if (this.modalOpen) {
      setTimeout(() => {
        this.modalOpen = false;
      }, 700);
    } else {
      this.modalOpen = true;
    }
  }
}
